module.exports = {
	"description": "The Button component represents a clickable button.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": false,
			"description": "Rendered content of the component"
		},
		"circular": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Displays a circular button"
		},
		"disabled": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Disables the button"
		},
		"fullWidth": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Stretch Button to fill its container"
		},
		"iconEnd": {
			"flowType": {
				"name": "React$Element",
				"elements": [
					{
						"name": "unknown"
					}
				],
				"raw": "React$Element<*>"
			},
			"required": false,
			"description": "Icon that goes after the children"
		},
		"iconStart": {
			"flowType": {
				"name": "React$Element",
				"elements": [
					{
						"name": "unknown"
					}
				],
				"raw": "React$Element<*>"
			},
			"required": false,
			"description": "Icon that goes before the children"
		},
		"minimal": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display a minimal button"
		},
		"onClick": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: Object) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "Object"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called with the click event"
		},
		"primary": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display a primary button"
		},
		"size": {
			"flowType": {
				"name": "union",
				"raw": "'small' | 'medium' | 'large' | 'jumbo'",
				"elements": [
					{
						"name": "literal",
						"value": "'small'"
					},
					{
						"name": "literal",
						"value": "'medium'"
					},
					{
						"name": "literal",
						"value": "'large'"
					},
					{
						"name": "literal",
						"value": "'jumbo'"
					}
				]
			},
			"required": false,
			"description": "Available sizes",
			"defaultValue": {
				"value": "'medium'",
				"computed": false
			}
		},
		"type": {
			"flowType": {
				"name": "union",
				"raw": "'button' | 'submit'",
				"elements": [
					{
						"name": "literal",
						"value": "'button'"
					},
					{
						"name": "literal",
						"value": "'submit'"
					}
				]
			},
			"required": false,
			"description": "Available types",
			"defaultValue": {
				"value": "'button'",
				"computed": false
			}
		},
		"variant": {
			"flowType": {
				"name": "union",
				"raw": "'regular' | 'danger' | 'success' | 'warning'",
				"elements": [
					{
						"name": "literal",
						"value": "'regular'"
					},
					{
						"name": "literal",
						"value": "'danger'"
					},
					{
						"name": "literal",
						"value": "'success'"
					},
					{
						"name": "literal",
						"value": "'warning'"
					}
				]
			},
			"required": false,
			"description": "Available variants",
			"defaultValue": {
				"value": "'regular'",
				"computed": false
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Button/Button.js
// module id = 1526
// module chunks = 0